module.exports = __webpack_public_path__ + "img/blueEye.30f64a6f.svg";